import { NICmsContentComponent } from '@icms/core/content';
import { IMenuTab } from '../../add-menu-tabs';

export namespace NPageHeader {
    export const BLOCK_ID = 'page-header';
    export const MEGANAV_GROUP_ID = 'meganav';

    export interface IBlockDataContent extends NICmsContentComponent.IData {
        additional: IVersionConfig;
    }

    export interface IComponent extends NICmsContentComponent.IData {
        toggleGroupId?: string;
        tabName?: string;
    }

    export interface IMenuItem {
        text: string;
        link?: string;
        link_class?: string;
        color?: string;
        hide: boolean;
        components: NICmsContentComponent.IData[];
        columns: IColumnsData[];
        promo_ctas?: IPromoCtaData[];
        promo_copy_colour?: string;
        promo_background_colour?: string;
        promo_copy?: string;
    }

    export interface IBlockContent extends NICmsContentComponent.IDataWithStyles, IVersionConfig {
        menuTabs: IMenuTab<IMenuItem>[];
        additional: IVersionConfig;
        logo_alt?: string;
        logo_image?: string;
    }

    export interface IColumnsData {
        columns?: string;
        width?: string;
        title?: string;
        cta_label?: string;
        promo_ctas?: IPromoCtaData[];
        list?: IColumnListElementData[];
    }

    export interface IColumnListElementData {
        cta_url?: string;
        ratio?: string;
        gtmSubcategory?: string;
        image?: string;
        text?: string;
        link?: string;
        linksList?: ISubmenuRowData[];
        variant: 'links_list' | 'image' | 'cta';
    }
    export interface IPromoCtaData {
        promo_cta_label?: string;
        promo_cta_url?: string;
    }
    export interface ISubmenuRowData {
        withImage?: boolean;
        withColours?: boolean;
        extraBorder?: boolean;
        colour?: string;
        image?: string;
        text: string;
        link?: string;
    }

    export interface IVersionState {
        /** Transparent background */
        transparent?: boolean;
        /** White text color */
        lightMode?: boolean;
        /** Hide up when start scrolling down */
        hideUp?: boolean;
    }

    export interface IVersionConfig {
        /** Transparent background */
        headerTransparent?: boolean;
        /** White text color */
        headerLightMode?: boolean;
        /** Hide up when start scrolling down */
        headerHideUp?: boolean;
    }

    export enum EClasses {
        transparent = 'page-header-transparent',
        lightMode = 'page-header-light-mode',
        hideUp = 'page-header-hide-up'
    }
}
